import { ItemAllocationMethodDTO } from '../DTOs/capital-account/ItemAllocationMethodDTO';
import { FinancialStatementItem } from '../common/FinancialStatementItem';
import { AllocationMethod } from '../../utils/capital-account/utils';

export class ItemAllocationMethod {
  public uuid: string;
  public item: FinancialStatementItem;
  public method: AllocationMethod;

  constructor(uuid: string, item: FinancialStatementItem, allocationMethod: AllocationMethod) {
    this.uuid = uuid;
    this.item = item;
    this.method = allocationMethod;
  }

  static toDTO(itemAllocationMethod: ItemAllocationMethod): ItemAllocationMethodDTO {
    return new ItemAllocationMethodDTO(
      itemAllocationMethod.uuid,
      FinancialStatementItem.toDTO(itemAllocationMethod.item),
      itemAllocationMethod.method,
    );
  }

  static toDTOList(itemAllocationMethods: ItemAllocationMethod[]): ItemAllocationMethodDTO[] {
    return itemAllocationMethods.map((itemAllocationMethod) => ItemAllocationMethod.toDTO(itemAllocationMethod));
  }
}
